module.exports = __webpack_public_path__ + "static/assets/e6a312c60ff95b8fc9d97b1028ba2158.png";